// extracted by css-extract-rspack-plugin
export default {"filter":"filter--oVWq1DIYup8D3bqr","chartBackground":"chart-background--AhekDZ3m6Y8Wv_zx","rangeColor":"range-color--gAsAtCWldAIR2QcG"};